import { createStepProgress } from './step-progress';

export function initStepsStandalone() {
    const containers = document.querySelectorAll('.steps-standalone');

    containers.forEach((container) => {
        const progress = createStepProgress(container, { translate: true });

        if (progress.stepItems.length === 0) return;

        progress.stepItems.forEach((item, index) => {
            item.style.cursor = 'pointer';
            item.addEventListener('click', () => {
                progress.goTo(index);
            });
        });

    });
}

